var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('p',[_vm._v(_vm._s(this.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }